import image1 from "../images/1.png";
import gift1 from "../images/gifts/1.png";

export const _albums = image1;

export const _giftAlbums = gift1;

export const _messages = [
    "ขอบคุณที่อยู่เคียงข้างกันมาตลอดนะคะ พี่รักหนูมากๆเลย",
    "",
];

export const _birthdayMessages = [
    "สุขสันต์วันเกิดนะ!",
    "วันนี้เป็นวันที่หนูได้เติบโตขึ้นอีกปีแล้วนะคะ พี่อยากจะขอบคุณที่หนูเป็นคนที่น่ารักและมีความสุขมากๆในชีวิตของพี่",
    "พี่ขอให้ปีนี้เป็นปีที่เต็มไปด้วยความสุข ความสำเร็จ และความรักที่ไม่มีที่สิ้นสุดสำหรับหนูนะคะ",
    "ขอให้ทุกความฝันของหนูเป็นจริง และพี่จะอยู่ข้างหนูเสมอ ",
    "รักหนูนะ จาก พี่มาร์คกี้สุดหล่อ",
];
